export const POST_MESSAGE_TYPE = 'web-lk-message';
